import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

const STATUS_STYLES = {
  PENDING_SCHEDULING: 'bg-orange-100 text-orange-700',
  SCHEDULED: 'bg-blue-100 text-blue-700',
  IN_PROGRESS: 'bg-yellow-100 text-yellow-700',
  COMPLETED: 'bg-green-100 text-green-700',
  CANCELLED: 'bg-red-100 text-red-700',
};

export default function Jobs() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => { api('/jobs').then(r => r.ok ? r.json() : []).then(setJobs); }, []);

  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Jobs</h2>
        <Link to="/jobs/new" className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700">New Job</Link>
      </div>
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">#</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Title</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Customer</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Schedule</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Crew</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {jobs.map(job => (
              <tr key={job.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm text-gray-500">{job.jobNumber}</td>
                <td className="px-6 py-4"><Link to={`/jobs/${job.id}`} className="text-teal-600 hover:text-teal-800 font-medium">{job.title}</Link></td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{job.companyName || job.contactName || '—'}</td>
                <td className="px-6 py-4 text-gray-600 text-sm hidden sm:table-cell">
                  {job.scheduledStart ? new Date(job.scheduledStart + 'T00:00:00').toLocaleDateString() : '—'}
                  {job.scheduledEnd ? ` – ${new Date(job.scheduledEnd + 'T00:00:00').toLocaleDateString()}` : ''}
                </td>
                <td className="px-6 py-4"><span className={`inline-flex px-2 py-1 rounded text-xs font-medium ${STATUS_STYLES[job.status] || ''}`}>{job.status?.replace('_', ' ')}</span></td>
                <td className="px-6 py-4 text-gray-600 text-sm hidden sm:table-cell">{job.assignments?.length || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {jobs.length === 0 && <div className="text-center py-12 text-gray-500">No jobs yet. Create one or convert an accepted estimate.</div>}
      </div>
    </Layout>
  );
}
